import { NavLink, useLocation } from 'react-router-dom';

import { useTheme } from '@emotion/react';

import { breakpoints } from '@/assets/themes/default/breakpoints';
import { useAppSelector } from '@/hooks/redux';
import useThemeMode from '@/hooks/useThemeMode';
import { useWindowDimensions } from '@/hooks/useWindowDimensions';
import styled, { StyledProp, css } from '@/styled';

import { navbarItems } from '..';

const whiteListPaths = [
  '/trilha',
  '/pacote',
  '/curso',
  '/cursos',
  '/portais',
  '/resumo',
  '/aulas/salvas',
  '/certificados',
  '/notas'
];

const SubMenu = ({ className }: StyledProp) => {
  const theme = useTheme();
  const { isDark } = useThemeMode();
  const user = useAppSelector(state => state.auth.user);
  const { width } = useWindowDimensions();
  const { pathname } = useLocation();

  if (!whiteListPaths.some(path => pathname.includes(path))) return null;

  if (width <= breakpoints.md || !user) return null;

  return (
    <>
      <div style={{ height: theme.variables.menuHeight }} />

      <div className={className}>
        <nav>
          <ul>
            {navbarItems.map(item => (
              <li key={item.path} id={`navbar-link${item.path.replaceAll('/', '-')}`}>
                <NavLink
                  className={({ isActive }) => `${isActive ? '--active' : ''} ${!isDark && isActive ? '--light' : ''}`}
                  to={item.path}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default styled(SubMenu)`
  ${({ theme }) => css`
    width: 100%;
    position: fixed;
    z-index: 5;
    background-color: ${theme.colorBgLayout};
    height: ${theme.variables.menuHeight}px;
    top: ${theme.variables.headerHeight}px;
    transition: ${theme.motionDurationMid};

    nav {
      height: 100%;

      ul {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        height: 100%;
        margin-bottom: 0;
        list-style-type: none;

        li {
          a {
            color: ${theme.colorTextBase};
            transition: ${theme.motionDurationMid};
            font-size: ${theme.space.pxToRem(18)};

            ${theme.breakpoints.down('lg')} {
              font-size: ${theme.space.pxToRem(16)};
            }

            &.--active,
            &:hover {
              color: ${theme.colorPrimary};
            }

            &.--light {
              color: ${theme.colorPrimary};
              font-weight: 600;
              border-bottom: solid 2px ${theme.colorPrimary};
            }
          }
        }
      }
    }
  `}
`;
